import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";
import AllProjects from "./components/AllProjects";

export default function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Mouse tracking for parallax effects
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  // Toggle dark mode
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <>
      {/* Shared Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div
          className={`absolute w-96 h-96 rounded-full opacity-20 blur-3xl transition-all duration-1000 ${
            isDarkMode ? "bg-blue-500" : "bg-blue-300"
          }`}
          style={{
            transform: `translate(${mousePosition.x * 0.02}px, ${
              mousePosition.y * 0.02
            }px)`,
            top: "10%",
            left: "80%",
          }}
        />
        <div
          className={`absolute w-80 h-80 rounded-full opacity-20 blur-3xl transition-all duration-1000 ${
            isDarkMode ? "bg-purple-500" : "bg-purple-300"
          }`}
          style={{
            transform: `translate(${mousePosition.x * -0.02}px, ${
              mousePosition.y * -0.02
            }px)`,
            top: "60%",
            left: "10%",
          }}
        />
      </div>

      <div
        className={`min-h-screen w-full overflow-x-hidden transition-all duration-500 relative z-10 ${
          isDarkMode
            ? "bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900"
            : "bg-gradient-to-br from-gray-50 via-white to-blue-50"
        }`}
      >
        <Routes>
          <Route
            path="/"
            element={
              <Portfolio
                isDarkMode={isDarkMode}
                toggleDarkMode={toggleDarkMode}
              />
            }
          />
          <Route
            path="/allProjects"
            element={
              <AllProjects
                isDarkMode={isDarkMode}
                toggleDarkMode={toggleDarkMode}
              />
            }
          />
        </Routes>
      </div>
    </>
  );
}
